"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateItem = void 0;
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var CalculatorHelpers_1 = __importDefault(require("./CalculatorHelpers"));
function calculateItem(itemModel, variableStore, discountService, billingScheduleOrchestrator, currency, cacheResults) {
    var _a, _b, _c;
    var taxableAmount = 0;
    var preTax = 0;
    if (!(0, Types_1.isPricedQuoteItem)(itemModel)) {
        return {
            taxable: 0,
            preTax: 0,
            preDiscount: 0,
            billingSchedule: { type: Types_1.BillingScheduleType.OneOff },
        };
    }
    var calculatorHelpers = new CalculatorHelpers_1.default(discountService);
    if (itemModel.type === Types_1.QuoteItemType.Variable) {
        if (!!itemModel.rate && (0, Types_1.isVariableRate)(itemModel.rate)) {
            var variable = variableStore.getVariable(itemModel.rate.variableId);
            if (variable != null) {
                preTax = ((_a = itemModel.quantity) !== null && _a !== void 0 ? _a : 0) * variable.getAmount((_b = itemModel.quantity) !== null && _b !== void 0 ? _b : 0);
            }
        }
    }
    else {
        preTax =
            ((_c = itemModel.quantity) !== null && _c !== void 0 ? _c : 0) * (itemModel.rate != null && itemModel.rate.rate != null ? itemModel.rate.rate : 0);
    }
    var preDiscount = preTax;
    preTax = calculatorHelpers.applyDiscount(preTax, itemModel.discount);
    if (!itemModel.isTaxExempt) {
        taxableAmount += preTax;
    }
    if (cacheResults) {
        itemModel.$cost = preTax;
        itemModel.$preDiscount = preDiscount;
    }
    return {
        taxable: calculatorHelpers.roundOffMoney(taxableAmount, currency),
        preTax: calculatorHelpers.roundOffMoney(preTax, currency),
        preDiscount: calculatorHelpers.roundOffMoney(preDiscount, currency),
        billingSchedule: billingScheduleOrchestrator.getBillingSchedule(itemModel),
    };
}
exports.calculateItem = calculateItem;
